export default __webpack_public_path__ + "a667e30da4dd908c17f67390bfcf30db.ttf";